import { Reveal } from "@/components/site/Reveal";
import { LegalShell } from "@/components/site/LegalShell";

const rows = [
  ["Unternehmen", "StackStork UG (haftungsbeschränkt)"],
  ["Anschrift", <>Hospitalstr. 26<br />c/o Ghassem Nezamipour Azari<br />63450 Hanau<br />Deutschland</>],
  ["Vertreten durch", "Ghassem Nezamipour Azari (Geschäftsführer)"],
  ["Registergericht", "Amtsgericht Hanau"],
  ["Registernummer", "HRB 100655"],
  ["Kontakt", <>E-Mail: <a href="mailto:kontakt@aufbruchwerk.de" data-testid="impressum-email-link" className="underline decoration-[var(--clay)] underline-offset-4 hover:text-[var(--clay)]">kontakt@aufbruchwerk.de</a><br />Telefon: <a href="tel:+491796735156" data-testid="impressum-phone-link" className="underline decoration-[var(--clay)] underline-offset-4 hover:text-[var(--clay)]">+49 179 6735156</a></>],
  ["Unternehmensgegenstand", "Entwicklung, Bereitstellung und Vermarktung von innovativen Lösungen in den Bereichen Informationstechnologie (IT) und Internet der Dinge (IoT)"],
  ["Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV", <>Ghassem Nezamipour Azari<br />Hospitalstr. 26, 63450 Hanau</>],
];

export default function Impressum() {
  return (
    <LegalShell testid="impressum" title={["Impressum"]} intro="Aufbruchwerk ist ein Angebot der StackStork UG (haftungsbeschränkt). Angaben gemäß § 5 DDG auf Grundlage der aktuellen Registereintragungen beim Amtsgericht Hanau.">
      <dl className="mt-12" data-testid="impressum-details">
        {rows.map(([k, v], i) => (
          <Reveal key={k} delay={i * 0.04}>
            <div className="grid gap-2 border-t border-[var(--line)] py-6 sm:grid-cols-3 sm:gap-8">
              <dt className="font-mono-d text-xs uppercase tracking-[0.18em] text-[var(--clay-2)] sm:pt-1">{k}</dt>
              <dd className="text-base leading-relaxed text-[var(--ink)] sm:col-span-2 md:text-lg">{v}</dd>
            </div>
          </Reveal>
        ))}
      </dl>
      <Reveal>
        <div className="mt-12 space-y-6 border-t border-[var(--line)] pt-10 text-sm leading-relaxed text-[var(--ink-2)]">
          <p><strong className="text-[var(--ink)]">Haftung für Inhalte.</strong> Die Inhalte dieser Seite wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen.</p>
          <p><strong className="text-[var(--ink)]">Haftung für Links.</strong> Für Inhalte externer Webseiten, auf die wir verlinken, sind ausschließlich deren Betreiber verantwortlich.</p>
          <p><strong className="text-[var(--ink)]">Urheberrecht.</strong> Die auf dieser Website erstellten Inhalte und Werke unterliegen dem deutschen Urheberrecht. Vervielfältigung und Verwendung außerhalb der Grenzen des Urheberrechts bedürfen der schriftlichen Zustimmung.</p>
        </div>
      </Reveal>
    </LegalShell>
  );
}
